import { render, staticRenderFns } from "./GridSection.vue?vue&type=template&id=cb0d710a&scoped=true&"
import script from "./GridSection.vue?vue&type=script&lang=js&"
export * from "./GridSection.vue?vue&type=script&lang=js&"
import style0 from "./GridSection.vue?vue&type=style&index=0&id=cb0d710a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0d710a",
  null
  
)

export default component.exports